<template>
  <v-layout justify-center align-center fill-height column>
    <div class="image-container mb-2 mr-3 ml-3">
      <img src="@/assets/maple-logo.png" class="image"/>
    </div>
    <h3>Página não encontrada</h3>
  </v-layout>
</template>

<script>
export default {
  name: 'not-found'
}
</script>

<style lang="stylus" scoped>
  .image
    width 100%
    height 100%
    background-position center center
    background-repeat no-repeat
    &-container
      display block
      text-align center
</style>
